/* eslint-disable security/detect-object-injection */
/* eslint-disable react/function-component-definition */
/* eslint-disable import/no-unresolved */
import { FormikProps } from "formik";
import { memo, FC, useEffect } from "react";
import { RiderPlanOption } from "src/config/constant";
import { findKeysByValue } from "src/helpers/FormDetails/ProposalDetails/resources";
import { showRiderConditionalField } from "src/helpers/FormDetails/resources";
import { ILoanDetails } from "src/redux/Reducers/loanDetails/interface";
import CustomSelect from "src/shared/CustomSelect";
import CustomTextField from "src/shared/CustomTextField";
import { useAppSelector } from "src/utils/hooks/useAppSelector";

interface Props {
  formik: FormikProps<ILoanDetails>;
  riderIndex: number;
}

const RiderDetails: FC<Props> = ({ formik, riderIndex }) => {
  const { masterMapping, productSelection, benefitType, planOptions, subPlanOptions } =
    useAppSelector((state) => state?.masterdata_reducer?.riders);

  const currentRider = formik?.values?.riderDetails?.[riderIndex];
  const getField = (arr: any, idx: number, key: string) =>
    Array.isArray(arr) && arr[idx] ? arr[idx][key] : undefined;

  const initializePlanOptions = () => {
    formik?.setFieldValue(`riderDetails[${riderIndex}].planOption`, "");
    formik?.setFieldValue(`riderDetails[${riderIndex}].planOptionCode`, "");
  };

  const initializeSubPlanOptions = () => {
    formik?.setFieldValue(`riderDetails[${riderIndex}].subPlanOption`, "");
    formik?.setFieldValue(`riderDetails[${riderIndex}].subPlanOptionCode`, "");
  };

  const initializeBenefitType = () => {
    formik?.setFieldValue(`riderDetails[${riderIndex}].benefitType`, "");
    formik?.setFieldValue(`riderDetails[${riderIndex}].benefitTypeCode`, "");
  };

  useEffect(() => {
    const isGCIR = currentRider?.productSelection === "GCIR";
    formik.setFieldValue(
      `riderDetails[${riderIndex}].productSelectionCode`,
      findKeysByValue(productSelection, currentRider?.productSelection)
    );
    initializeBenefitType();

    if (isGCIR) {
      initializePlanOptions();
      initializeSubPlanOptions();
    }
  }, [currentRider?.productSelection]);

  useEffect(() => {
    formik.setFieldValue(
      `riderDetails[${riderIndex}].benefitTypeCode`,
      findKeysByValue(benefitType, currentRider?.benefitType)
    );
    initializePlanOptions();
    initializeSubPlanOptions();
  }, [currentRider?.benefitType]);

  useEffect(() => {
    if (currentRider?.productSelection === "GCIR") return;
    formik.setFieldValue(
      `riderDetails[${riderIndex}].planOptionCode`,
      findKeysByValue(planOptions, currentRider?.planOption)
    );
    initializeSubPlanOptions();
    formik?.setFieldValue(`riderDetails[${riderIndex}].emi`, "");
  }, [currentRider?.planOption]);

  useEffect(() => {
    if (currentRider?.planOptionCode === RiderPlanOption.EMISUPPORT) {
      const calcSumAssured = !Number.isNaN(currentRider?.emi) && Number(currentRider?.emi) * 60;
      if (calcSumAssured) {
        formik?.setFieldValue(`riderDetails[${riderIndex}].sumAssured`, calcSumAssured);
      }
    }
  }, [currentRider?.emi, currentRider?.planOptionCode]);

  useEffect(() => {
    formik.setFieldValue(
      `riderDetails[${riderIndex}].subPlanOptionCode`,
      findKeysByValue(subPlanOptions, currentRider?.subPlanOption)
    );
  }, [currentRider?.subPlanOption]);

  const riderConditionalFields = showRiderConditionalField(currentRider, masterMapping);

  console.log("formik values", formik?.values, formik?.errors);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-10 gap-y-6">
      {!!riderConditionalFields?.productSelection && (
        <CustomSelect
          label="Rider Product Selection"
          options={Object.keys(masterMapping || {})?.map((ele) => productSelection?.[ele])}
          onChange={formik.handleChange}
          setFieldTouched={formik.setFieldTouched}
          name={`riderDetails[${riderIndex}].productSelection`}
          value={getField(formik?.values?.riderDetails, riderIndex, "productSelection") || ""}
          error={getField(formik?.errors?.riderDetails, riderIndex, "productSelection")}
          touched={getField(formik?.touched?.riderDetails, riderIndex, "productSelection")}
        />
      )}
      {!!riderConditionalFields?.benefitType && (
        <CustomSelect
          label="Rider Benefit Type"
          name={`riderDetails[${riderIndex}].benefitType`}
          options={Object.keys(masterMapping?.[currentRider?.productSelectionCode] || {})?.map(
            (ele) => benefitType?.[ele]
          )}
          onChange={formik.handleChange}
          setFieldTouched={formik.setFieldTouched}
          value={getField(formik?.values?.riderDetails, riderIndex, "benefitType") || ""}
          error={getField(formik?.errors?.riderDetails, riderIndex, "benefitType")}
          touched={getField(formik?.touched?.riderDetails, riderIndex, "benefitType")}
          disabledField={!currentRider?.productSelection}
        />
      )}
      {!!riderConditionalFields?.planOptions && (
        <CustomSelect
          label="Rider Plan Options"
          name={`riderDetails[${riderIndex}].planOption`}
          options={Object.keys(
            masterMapping?.[currentRider?.productSelectionCode]?.[currentRider?.benefitTypeCode] ||
              {}
          )?.map((ele) => planOptions?.[ele])}
          onChange={formik.handleChange}
          setFieldTouched={formik.setFieldTouched}
          value={getField(formik?.values?.riderDetails, riderIndex, "planOption") || ""}
          error={getField(formik?.errors?.riderDetails, riderIndex, "planOption")}
          touched={getField(formik?.touched?.riderDetails, riderIndex, "planOption")}
          disabledField={!currentRider?.benefitType}
        />
      )}
      {!!riderConditionalFields?.subPlanOptions && (
        <CustomSelect
          label="Rider Plan Sub-option"
          name={`riderDetails[${riderIndex}].subPlanOption`}
          options={Object.keys(
            masterMapping?.[currentRider?.productSelectionCode]?.[currentRider?.benefitTypeCode]?.[
              currentRider?.planOptionCode!
            ] || {}
          )?.map((ele) => subPlanOptions?.[ele])}
          onChange={formik.handleChange}
          setFieldTouched={formik.setFieldTouched}
          value={getField(formik?.values?.riderDetails, riderIndex, "subPlanOption") || ""}
          error={getField(formik?.errors?.riderDetails, riderIndex, "subPlanOption")}
          touched={getField(formik?.touched?.riderDetails, riderIndex, "subPlanOption")}
          disabledField={!currentRider?.planOption}
        />
      )}
      {getField(formik.values.riderDetails, riderIndex, "planOptionCode") ===
        RiderPlanOption.EMISUPPORT && (
        <CustomTextField
          label="EMI"
          onChange={formik.handleChange}
          handleBlur={formik.handleBlur}
          value={getField(formik?.values?.riderDetails, riderIndex, "emi") || ""}
          name={`riderDetails[${riderIndex}].emi`}
          error={getField(formik?.errors?.riderDetails, riderIndex, "emi")}
          touched={getField(formik?.touched?.riderDetails, riderIndex, "emi")}
        />
      )}
      <CustomTextField
        label="Rider PT (Months)"
        onChange={formik.handleChange}
        handleBlur={formik.handleBlur}
        value={currentRider?.policyTerm || ""}
        name={`riderDetails[${riderIndex}].policyTerm`}
        error={getField(formik?.errors?.riderDetails, riderIndex, "policyTerm")}
        touched={getField(formik?.touched?.riderDetails, riderIndex, "policyTerm")}
      />
      <CustomTextField
        label="Rider PPT (Years)"
        onChange={formik.handleChange}
        handleBlur={formik.handleBlur}
        value={currentRider?.premiumPolicyTerm || ""}
        name={`riderDetails[${riderIndex}].premiumPolicyTerm`}
        error={getField(formik?.errors?.riderDetails, riderIndex, "premiumPolicyTerm")}
        touched={getField(formik?.touched?.riderDetails, riderIndex, "premiumPolicyTerm")}
      />
      <CustomTextField
        label="Rider Sum Assured"
        onChange={formik.handleChange}
        handleBlur={formik.handleBlur}
        value={currentRider?.sumAssured || ""}
        name={`riderDetails[${riderIndex}].sumAssured`}
        error={getField(formik?.errors?.riderDetails, riderIndex, "sumAssured")}
        touched={getField(formik?.touched?.riderDetails, riderIndex, "sumAssured")}
        disabledField={currentRider?.planOptionCode === RiderPlanOption.EMISUPPORT}
      />
    </div>
  );
};

export default memo(RiderDetails);
